import Icon from "@expo/vector-icons/MaterialIcons";
import type MaterialIcons from "@expo/vector-icons/MaterialIcons";
import Box from "@memorang/ui/src/components/Box";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

export type ToolActionProps = {
	text: string;
	icon: string;
};

const ToolAction = ({ text, icon }: ToolActionProps) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			display="flex"
			alignSelf="flex-start"
			alignItems="center"
			paddingHorizontal={12}
			paddingVertical={6}
			backgroundColor={theme.colors.secondaryContainer}
			borderRadius={28}
		>
			<Icon
				name={icon as keyof typeof MaterialIcons.glyphMap}
				size={18}
				color={theme.colors.primary}
			/>
			<Box marginLeft={8}>
				<Text
					variant="labelLarge"
					style={{ color: theme.colors.onSecondaryContainer }}
				>
					{text}
				</Text>
			</Box>
		</Box>
	);
};

export default ToolAction;
